import { EditAttributes } from "design-system/types/types";
import { Link } from "design-system/components/primitives/link/link";

export interface ArticleFooterAuthorInfoProps {
  name: string;
  link?: string;
  email?: string;
  phone?: string;

  editAttributes?: {
    name?: EditAttributes;
    email?: EditAttributes;
    phone?: EditAttributes;
  };
}

export function ArticleFooterAuthorInfo({
  name,
  link,
  phone,
  editAttributes,
}: ArticleFooterAuthorInfoProps) {
  return (
    <address className="hbs-article-footer__author">
      <span {...editAttributes?.name}>
        {link ? <Link href={link}>{name}</Link> : name}
      </span>
      <br />
      {/* Hiding email for MBA launch until a security decision is made CMS-3576 */}
      {/* {email && (
        <>
          <span {...editAttributes?.email}>{email}</span>
          <br />
        </>
      )} */}
      {phone && (
        <>
          <span {...editAttributes?.phone}>{phone}</span>
          <br />
        </>
      )}
    </address>
  );
}
